module.exports = __webpack_public_path__ + "img/next_active_icon.8a3bd85.png";